<template>
  <v-dialog v-model="show" persistent max-width="450">
    <v-card>
      <v-card-title>Mark excise as filed</v-card-title>
      <v-divider/>

      <v-container>
        <v-row>
          <v-col cols="7" class="text-right">File for period end:</v-col>
          <v-col class="font-weight-bold">{{periodEnd | formatDate}}</v-col>
        </v-row>
        <v-row v-if="thisPeriod" class="warning--text">
          <v-col>Cannot file Excise reports for the current period until the period ends.</v-col>
        </v-row>
        <template v-else>
          <v-row>
            <v-col cols="7" class="text-right">Due:</v-col>
            <v-col class="font-weight-bold">{{dueDate | formatDate}}</v-col>
          </v-row>
          <v-row v-for="l of licenses" :key="l.license">
            <v-col cols="7" class="text-right">{{l.license}} duty payable:</v-col>
            <v-col>{{l.due | currency}}</v-col>
          </v-row>
          <v-row>
            <v-col cols="7" class="text-right font-weight-bold">
              Total duty payable:
            </v-col>
            <v-col class="font-weight-bold">{{totalDue | currency}}</v-col>
          </v-row>
          <v-row v-if="totalDue && company.settings.exciseCreateReceipt">
            <v-col class="mx-1">
              An inventory receipt will be created for the excise payable.
            </v-col>
          </v-row>
          <v-row>
            <v-col class="warning--text mx-1">
              This will mark your excise returns as filed and close the books for this excise period.
              No further transactions affecting excise will be allowed in this period.
            </v-col>
          </v-row>
        </template>
      </v-container>

      <v-divider/>
      <v-card-actions class="px-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="cancel">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving" :disabled="thisPeriod">File</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>


<script>
import {add,format,lastDayOfMonth} from 'date-fns';

export default {
  name: 'ReportsExciseFile',
  props: {
    value: {type:Boolean, required:true}
  },
  data() {
    return {
      show: this.value,
      saving: false,
      thisPeriod: false,
      periodEnd: null,
      dueDate: null,
      licenses: [],
      totalDue: 0
    }
  },
  computed: {
    company() {
      return this.$store.getters.company;
    }
  },
  watch: {
    value() {
      this.show = this.value;
      if (this.show)
        this.init();
    },
  },
  async created() {
  },
  methods: {
    async init() {
      this.licenses = [];
      const sites = this.$store.getters.sites(true, true).filter(site => !site.nonExcise);
      const warehouseLicenses = [...new Set(sites.map(site => site.warehouseLicense))];
      const spiritsLicenses = [...new Set(sites.map(site => site.spiritsLicense))];
      let date;
      if (this.company.excisePeriodEnd !== '1999-12-31')
        date = lastDayOfMonth(add(new Date(this.company.excisePeriodEnd),{days:2}));    // Next period from last filed
      else
        date = lastDayOfMonth(add(new Date(),{months:-1})); // end of last month
      this.periodEnd = format(date, 'yyyy-MM-dd');
      this.dueDate = format(lastDayOfMonth(add(date, {days:1})),'yyyy-MM-dd');
      this.thisPeriod = this.periodEnd > format(new Date(),'yyyy-MM-dd');

      // Get balance due for each warehouse/spirits license
      this.totalDue = 0;
      for (const license of warehouseLicenses) {
        const results2 = await this.$apiCall(`query ReportsExciseFile($license:String!,$date:Date!) {
                                                exciseWarehouseReport(license:$license,date:$date) {exciseNet}
                                              }`,
                                            {license,date:this.periodEnd.substring(0,8)+'01'});
        if (!results2.error) {
          this.licenses.push({license,due:results2.data.exciseWarehouseReport.exciseNet});
          this.totalDue = this.$roundNumber(this.totalDue + results2.data.exciseWarehouseReport.exciseNet);
        }
      }
      for (const license of spiritsLicenses) {
        const results2 = await this.$apiCall(`query ReportsExciseFile($license:String!,$date:Date!) {
                                                exciseSpiritsReport(license:$license,date:$date) {excisePayable}
                                              }`,
                                            {license,date:this.periodEnd.substring(0,8)+'01'});
        if (!results2.error) {
          this.licenses.push({license,due:results2.data.exciseSpiritsReport.excisePayable});
          this.totalDue = this.$roundNumber(this.totalDue + results2.data.exciseSpiritsReport.excisePayable);
        }
      }
    },
    async save() {
      this.saving = true;
      const results = await this.$apiCall(`mutation ReportsExciseFile($excisePeriodEnd:Date!, $amount:Float!) {
                                              exciseFile(excisePeriodEnd:$excisePeriodEnd, amount:$amount) {excisePeriodEnd}
                                            }`,
                                          {excisePeriodEnd:this.periodEnd, amount:this.totalDue});
      this.saving = false;
      if (!results.error) {
        this.company.excisePeriodEnd = this.periodEnd;
        this.$store.commit('setError', {message:'Excise reports filed',type:'success'});
        this.$emit('filed', true);
        this.cancel();
      }
    },
    cancel() {
      this.show = false;
      this.$emit('input', false);
    },
  }
}
</script>